import $ from 'jquery';
import 'dotdotdot';
import smoothScroll from 'smooth-scroll';

function applyClamp(list, eq) {
  for (let i = eq, j = list.length; i < j; i += 1) {
    const items = list.eq(i).find('[data-ellipsis]');

    for (let k = 0, m = items.length; k < m; k += 1) {
      items.eq(k).dotdotdot();
    }
  }
}

class NewsPagination {
  constructor(elm) {
    this.elm = $(elm);

    this.loadForm = this.elm.find('[data-news-pagination-load-form]').first();
    this.loadButton = this.elm.find('[data-news-pagination-load-button]').first();
    this.nextPageInput = this.loadForm.find('[name="paged"]').first();
    this.loadButtonLoadingText = this.loadButton.data('loading-text');
    this.loadButtonDefaultText = this.loadButton.text();
    this.placeholder = this.elm.find('[data-news-pagination-placeholder]').first();
    this.pageSize = 1;
    this.page = this.nextPageInput.val();

    this.setupListeners();
  }

  setupListeners() {
    this.loadForm.on('submit', this.onLoadFormSubmit.bind(this));
  }

  onLoadFormSubmit(event) {
    event.preventDefault();
    this.loadButton.text(this.loadButtonLoadingText);
    this.loadButton.prop('disabled', true);
    this.doRequest();
  }

  doRequest() {
    const data = this.loadForm.serialize();

    $.ajax({ url: this.loadForm.attr('action'), data })
      .done(this.onRequestSuccess.bind(this))
      .always(this.onRequestComplete.bind(this));
  }

  onRequestSuccess(data, textStatus, jqXHR) {
    const hasNextPage = jqXHR.getResponseHeader('HasNextPage');
    const nextPage = jqXHR.getResponseHeader('NextPage');
    const eq = (this.pageSize * (this.page - 1));

    this.page = nextPage;
    this.placeholder.append(data);

    const newsList = this.placeholder.children();
    const news = newsList.eq(eq);

    if (hasNextPage === 'true') {
      this.nextPageInput.val(nextPage);
    } else {
      this.loadForm.remove();
    }

    applyClamp(newsList, eq);
    smoothScroll.animateScroll(`#${news.attr('id')}`);
  }

  onRequestComplete() {
    this.loadButton.text(this.loadButtonDefaultText);
    this.loadButton.prop('disabled', false);
  }
}

export default {
  create(selector) {
    const instances = [];
    const elms = document.querySelectorAll(selector);

    for (let i = 0; i < elms.length; i += 1) {
      instances.push(new NewsPagination(elms[i]));
    }

    return instances;
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/NewsPagination.js